import _regeneratorRuntime from "babel-runtime/regenerator";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";

import dict from "@/tools/dict";

export default {
  loadBusiData: function loadBusiData(newData, busiData) {
    var bizData = busiData.BIZ_DATA;
    var busiCode = busiData.BUSI_CODE;
    return this.getCommissionRates(bizData, busiCode);
  },


  getCommissionRates: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(bizData, busiCode) {
      var openAcctInfo, orgCode, accountInfo, newAccountCode, cuacctClsFeeSn, cuacctCls, params, busicodeStr, agmtList, i, res, resultArr, dictObj, commissionRates;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              openAcctInfo = bizData.OPENTMPL_INFO;
              orgCode = openAcctInfo.INT_ORG;
              accountInfo = _.get(bizData, "CUACCT_INFO_LIST[0]") || {};
              newAccountCode = accountInfo.NEW_ACCOUNT_CODE;
              cuacctClsFeeSn = accountInfo.CUACCT_CLS_FEE_SN;
              cuacctCls = accountInfo.CUACCT_CLS;
              params = {};

              if (busiCode == "QS421") {
                busicodeStr = ["QS421"];
                agmtList = bizData.AGMT_LIST;

                for (i = 0; i < agmtList.length; i++) {
                  busicodeStr.push(agmtList[i].BUSI_CODE);
                }
                params.BUSI_CODE = busicodeStr.join(",");
              } else {
                params.BUSI_CODE = "QS420";
              }
              params.BRANCHES = orgCode;
              params.CUACCT_CODE = newAccountCode;
              params.CLS_FEE = cuacctClsFeeSn;
              params.ACC_CLS = cuacctCls;
              params.SYS_CODES = "5";
              params.service = "QS080030";
              _context.next = 16;
              return vm.$syscfg.K_Request("QS080030", params);

            case 16:
              res = _context.sent;

              if (!(res.Code === "0")) {
                _context.next = 28;
                break;
              }

              resultArr = res.Data;
              _context.next = 21;
              return dict.transformDict(resultArr, [{ "BUSI_FEE_CLS_TYPE": "FEE_CLS_TYPE" }, { "MARKETBOARD": "STKBD" }, "INVESTMENT_PRODUCTS"]);

            case 21:
              dictObj = _context.sent;
              commissionRates = {};

              commissionRates.KGOB_CUACCT_CODE = newAccountCode;
              commissionRates.FEE_RATE_DATA = dictObj;
              return _context.abrupt("return", commissionRates);

            case 28:
              consoleLog("佣金费率查询失败");
              return _context.abrupt("return", {});

            case 30:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function getCommissionRates(_x, _x2) {
      return _ref.apply(this, arguments);
    }

    return getCommissionRates;
  }()
};


//////////////////
// WEBPACK FOOTER
// ./src/assets/busi-paper/prints/GUOTOU/XID.js
// module id = 1134
// module chunks = 2